export default __webpack_public_path__ + "static/media/MODALfrijol_EN.2fc7fe57.jpg";